import { Fragment, useEffect, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/client/react";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import IndicacionGrilla from "../../IndicacionGrilla";
import { EscalonesGrafico } from "../../../../../../components/EscalonesGrafico";
import useCalculoEscalones from "../../../../../../hooks/useCalculoEscalones";
import GET_COMBO_VISITA_VALOR, { adaptCombosVisitas } from "../../../../../../data/graphQL/queries/MisVisitas/getCombosVisitaValor";

export default function Indicacion({ combosVisita, readOnly, visita, idEvaluacion, programa, esUrgencia }) {
    const COMBO_VISITA_PRODUCTO = 'Producto';
    const COMBO_VISITA_MODALIDAD_EXPANSION = 'ModalidadExpansion';
    const [comboProductoOptions, setComboProductoOptions] = useState([]);
    const [comboModalidadOptions, setComboModalidadOptions] = useState([]);

    const datosEscalonesMagistral = useCalculoEscalones({
        volumenBAP: visita?.volumenMagistral,
        duracionMeseta: visita?.duracionMesetaMagistral,
        cantidadEscalones: visita?.cantidadEscalonesMagistral,
    });

    const datosEscalonesEstandar = useCalculoEscalones({
        volumenBAP: visita?.volumenEstandar,
        duracionMeseta: visita?.duracionMesetaEstandar,
        cantidadEscalones: visita?.cantidadEscalonesEstandar,
    });

    const [loadComboProducto, { data: dataComboProducto }] = useLazyQuery(GET_COMBO_VISITA_VALOR, {
        fetchPolicy: "no-cache"
    });

    const [loadComboModalidad, { data: dataComboModalidad }] = useLazyQuery(GET_COMBO_VISITA_VALOR, {
        fetchPolicy: "no-cache"
    });

    useEffect(() => {
        if (!dataComboProducto) return;
        setComboProductoOptions(adaptCombosVisitas(dataComboProducto));
    }, [dataComboProducto]);


    useEffect(() => {
        if (!dataComboModalidad) return;
        setComboModalidadOptions(adaptCombosVisitas(dataComboModalidad));
    }, [dataComboModalidad]);

    useEffect(() => {
        if (!Array.isArray(combosVisita) || combosVisita.length === 0) return;

        const productoId = combosVisita?.find((c) => c.comboName === COMBO_VISITA_PRODUCTO)?.id;
        const modalidadId = combosVisita?.find((c) => c.comboName === COMBO_VISITA_MODALIDAD_EXPANSION)?.id;

        if (Number.isInteger(productoId)) {
            loadComboProducto({ variables: { idComboVisita: productoId } });
        }
        if (Number.isInteger(modalidadId)) {
            loadComboModalidad({ variables: { idComboVisita: modalidadId } });
        }
    }, [combosVisita, loadComboProducto, loadComboModalidad]);

    const formattedInputs = useMemo(() => {
        return inputs.map((input) => {
            const newInput = { ...input };
            const hasExpansion = visita?.expansion === true;

            switch (newInput.name) {
                case "cambioSNG":
                    newInput.hidden = (visita.tipoAcceso !== 'SNG' && visita.tipoAcceso !== 'Sonda postpilórica')
                    break;
                case "indicacion":
                    newInput.hidden = programa === 'AP' && programa === 'NPID';
                    break;
                case "bAPMagistral":
                    newInput.hidden = programa !== 'AP' && programa !== 'NPID';
                    break;
                case "volumenMagistral":
                    newInput.hidden = programa !== 'AP' && programa !== 'NPID';
                    break;
                case "volumenEstandar":
                    newInput.hidden = programa !== 'AP' && programa !== 'NPID';
                    break;
                case "graficoEscalonesMagistral":
                    newInput.hidden = programa !== 'AP';
                    break;
                case "bAPEstandar":
                    newInput.hidden = programa !== 'AP' && programa !== 'NPID';
                    break;
                case "graficoEscalonesEstandar":
                case "ubicacion":
                case "lumenes":
                case "expansion":
                case "volumen":
                case "selladoCateter":
                    newInput.hidden = programa !== 'AP';
                    break;
                case "conexionSemana":
                    newInput.hidden = programa !== 'AP' && programa !== 'NPID';
                    break;
                case "conexionSemanaMagistral":
                    newInput.hidden = programa !== 'AP' && programa !== 'NPID';
                    break;
                case "insumoBAP":
                    newInput.hidden = programa !== 'AP';
                    break;
                case "idComboVisitaValorProducto":
                    newInput.hidden = programa !== 'AP';
                    newInput.options = comboProductoOptions;
                    break;
                case "idComboVisitaValorExpansion":
                    newInput.hidden = programa !== 'AP';
                    newInput.options = comboModalidadOptions;
                    break;
                case "formaPreparacion":
                case "suplementoVitaminicos":
                case "suplemento":
                case "indicacionSuplemento":
                case "llevaBomba":
                case "hidratacion":
                case "indicacionHidratacion":
                    newInput.hidden = programa !== 'AE' && programa !== 'CEAE';
                    break;
                case "modoInfusion":
                case "tipoAcceso":
                case "flujo":
                case "indicacionComentario":
                case "indicacionEspecial":
                    newInput.hidden = programa === 'NPID';
                    break;
                default:
                    break;
            }

            if (esUrgencia) newInput.required = false;

            if (readOnly) newInput.disabled = true;

            return newInput;
        });
    }, [readOnly, visita, programa, esUrgencia, comboProductoOptions, comboModalidadOptions]);

    return (
        <CardBox title={visita.programa}>
            {formattedInputs
                .filter((input) => !input.hidden)
                .map((input) => (
                    <Fragment key={input.name}>
                        {input.name === 'idComboVisitaValorExpansion' &&
                            (<RenderInputByTypeMobile
                                key={input.name}
                                input={input}
                                value={input.renderValue(visita[input.name], comboModalidadOptions) || '-'}
                                handleChange={() => { }}
                            />)}
                        {input.name === 'idComboVisitaValorProducto' &&
                            (<RenderInputByTypeMobile
                                key={input.name}
                                input={input}
                                value={input.renderValue(visita[input.name], comboProductoOptions) || '-'}
                                handleChange={() => { }}
                            />)}
                        {input.name !== 'indicacion' &&
                            input.name !== 'graficoEscalonesMagistral' &&
                            input.name !== 'graficoEscalonesEstandar' &&
                            input.name !== 'idComboVisitaValorProducto' &&
                            input.name !== 'idComboVisitaValorExpansion' &&
                            <RenderInputByTypeMobile
                                key={input.name}
                                input={input}
                                value={input.renderValue ? input.renderValue(visita[input.name]) : visita[input.name] || '-'}
                                handleChange={() => { }}
                            />}
                        {input.name === 'indicacion' && (
                            <IndicacionGrilla idEvaluacion={idEvaluacion} />
                        )}
                        {input.name === 'graficoEscalonesMagistral' && (
                            <EscalonesGrafico
                                {...datosEscalonesMagistral}
                                cantidadEscalones={visita?.cantidadEscalonesMagistral}
                                duracionHoras={visita?.duracionMesetaMagistral}
                            />)
                        }
                        {input.name === 'graficoEscalonesEstandar' && (
                            <EscalonesGrafico
                                {...datosEscalonesEstandar}
                                cantidadEscalones={visita?.cantidadEscalonesEstandar}
                                duracionHoras={visita?.duracionMesetaEstandar}
                            />)
                        }
                    </Fragment>
                )
                )}
        </CardBox>
    );
}

const inputs = [
    {
        displayName: "Modo de infusión",
        name: "modoInfusion",
        type: 'infoRow'
    },
    {
        displayName: "BAP Magistral",
        name: "bAPMagistral",
        lightTitle: true,
        type: "infoRow",
        renderValue: (value) => (value ? 'SI' : 'NO')
    },
    {
        displayName: "Volumen",
        name: "volumenMagistral",
        lightTitle: true,
        type: "infoRow"
    },
    {
        displayName: "Conexion Semana",
        name: "conexionSemanaMagistral",
        lightTitle: true,
        type: "infoRow"
    },
    {
        displayName: "Grafico Escalones Magistral",
        name: "graficoEscalonesMagistral",
    },
    {
        displayName: "BAP Estandar",
        name: "bAPEstandar",
        lightTitle: true,
        type: "infoRow",
        renderValue: (value) => (value ? 'SI' : 'NO')
    },
    {
        displayName: "Indicación",
        name: "insumoBAP",
        type: 'infoRow'
    },
    {
        displayName: "Volumen",
        name: "volumenEstandar",
        lightTitle: true,
        type: "infoRow"
    },
    {
        displayName: "Conexion Semana",
        name: "conexionSemana",
        lightTitle: true,
        type: "infoRow"
    },
    {
        displayName: "Grafico Escalones Estandar",
        name: "graficoEscalonesEstandar",
    },
    {
        displayName: "Lleva Bomba",
        name: "llevaBomba",
        type: 'infoRow'
    },
    {
        displayName: "Forma de preparación",
        name: "formaPreparacion",
        type: 'infoRow'
    },
    {
        displayName: "Sellado de Cateter",
        name: "selladoCateter",
        type: 'infoRow'
    },
    {
        displayName: "Tipo de Acceso",
        name: "tipoAcceso",
        type: 'infoRow'
    },
    {
        displayName: "Cambio de SNG en Domicilio",
        name: "cambioSNG",
        type: 'infoRow'
    },
    {
        displayName: "Indicacion",
        name: "indicacion",
        type: 'infoRow'
    },
    {
        displayName: "Ubicación",
        name: "ubicacion",
        type: 'infoRow'
    },
    {
        displayName: "Lúmenes",
        name: "lumenes",
        type: 'infoRow'
    },
    {
        displayName: "Expansión",
        name: "expansion",
        type: 'infoRow',
        renderValue: (value) => (value?.toLowerCase() === 'true' ? 'SI' : 'NO')
    },
    {
        displayName: "Producto",
        name: "idComboVisitaValorProducto",
        type: 'infoRow',
        renderValue: (value, comboProductoOptions) => (comboProductoOptions?.find((option) => option.id === value)?.displayName || '-')
    },
    {
        name: "idComboVisitaValorExpansion",
        displayName: "Modalidad de expansión",
        type: 'infoRow',
        renderValue: (value, comboModalidadOptions) => (comboModalidadOptions?.find((option) => option.id === value)?.displayName || '-')
    },
    {
        displayName: "Volumen",
        name: "volumen",
        type: 'infoRow'
    },
    {
        displayName: "Flujo",
        name: "flujo",
        type: 'infoRow'
    },
    {
        displayName: "Hidratación",
        name: "hidratacion",
        type: 'infoRow',
        renderValue: (value) => (value ? 'SI' : 'NO')
    },
    {
        displayName: "Indicación de Hidratación",
        name: "indicacionHidratacion",
        type: 'infoRow'
    },
    {
        displayName: "Suplementos vitamínicos",
        name: "suplementoVitaminicos",
        type: 'infoRow',
        renderValue: (value) => (value ? 'SI' : 'NO')
    },
    {
        displayName: "Suplementos",
        name: "suplemento",
        type: 'infoRow'
    },
    {
        displayName: "Indicación de suplementos",
        name: "indicacionSuplemento",
        type: 'infoRow'
    },
    {
        displayName: "Comentarios de indicación",
        name: "indicacionComentario",
        type: 'infoRow'
    },
    {
        displayName: "Indicación Especial",
        name: "indicacionEspecial",
        type: 'infoRow'
    },
];